import {
    apiRequest,
    PengaturanAccessDetail,
    PengaturanAccessUpdate
} from "../../../../../services/adapters/kepegawaian/accessService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", PengaturanAccessUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", PengaturanAccessDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default UpdateRepository